// extracted by mini-css-extract-plugin
export var closeButton = "_n0-1";
export var closeX = "_n0-3";
export var container = "_n0-0";
export var image = "_n0-2";